$(document).delegate('[data-tooltip-gc]', 'mouseover', function() {
    $(this).find('.tooltipGC__messageContainer').removeClass('tooltipGC__messageContainer--hidden')
});

$(document).delegate('[data-tooltip-gc]', 'mouseleave', function() {
    $(this).find('.tooltipGC__messageContainer').addClass('tooltipGC__messageContainer--hidden')
});
